import { render } from "./CouponManage.vue?vue&type=template&id=42a2eb18&scoped=true"
import script from "./CouponManage.vue?vue&type=script&lang=js"
export * from "./CouponManage.vue?vue&type=script&lang=js"

import "./CouponManage.vue?vue&type=style&index=0&id=42a2eb18&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a2eb18"]])

export default __exports__